export default {
  apply: '/apply',
  error: '/error',
  start: '/',
  zero: '/zero',
  loadingP2X: '/loading'
}
